import * as ng from 'angular';
import * as nggt from 'angular-gettext';

import { State, Country, SiteConfig } from '../shared';

export class MinAgeService {
   static $inject = ['gettextCatalog', 'config'];

   constructor(
      private gettextCatalog:nggt.gettextCatalog,
      private config:SiteConfig
   ) { }

   getMinAge(state:State, country:Country) {
      let ageType = this.config.campaign.ageRequirementType;
      if (ageType === 'other') {
         return this.config.campaign.settings.minAgeOther;
      }

      if (state && state.minAge && state.minAge[ageType]) {
         return state.minAge[ageType];
      }

      return country.minAge[ageType];
   }

   getMinAgeError() {
      let error = this.gettextCatalog.getString('You must be of legal drinking age to continue.');
      let ageType = this.config.campaign.ageRequirementType;

      if (ageType === 'auto') {
         error = this.gettextCatalog.getString('You must be of legal driving age to continue.');
      } else if (ageType === 'other') {
         error = this.gettextCatalog.getString('You must be above {{minAge}} years old to continue.', {
            minAge: this.config.campaign.settings.minAgeOther
         });
      }

      return error;
   }
}

ng.module('selfReg')
   .service('minAgeService', MinAgeService);
